import { AppThunk } from '@/app/store';
import { parseAxiosResponse } from '@/utils/parse_axios_response';
import { sleep } from '@/utils/sleep';
import { ErrorPosition } from '@/slicers/response';
import { setResponse } from '@/slicers/response';
import { setFlashError, setFlashSuccess } from '@/slicers/flash';
import {
  companySwitchGetsSucces,
  companySwitchGetSuccess,
  companySwitchUpdateSuccess,
  companySwitchRentSuccess,
  companySwitchesDetachById,
  companyAddUnAttachSwitches,
  companySetUnAttachSwitches,
  companySetUnAttachSwitchesModule,
} from '@/slicers/companySwitches';
import { Switch } from '@/slicers/switches';
import { MainApiCaller, TApiCaller } from '@/api-service';

export const readSwitchWithToSwitchWithMap = (
  readSwitchWith: Record<string, any>
): Switch => {
  const { units, ...other } = readSwitchWith;
  let switchWith: Switch = { ...other, unitsByNumber: {} } as any;
  return switchWith;
};

@MainApiCaller('/normal_companies')
class CompaniesSwitchesRequest {
  caller!: TApiCaller;

  index(companyId: string) {
    return {
      request: (): AppThunk => async (dispatch) => {
        const response = await this.caller.GET(`/${companyId}/switches`);
        if (response.status === 200) {
          dispatch(
            companySwitchGetsSucces(
              response.data.map((readSwitchWith: any) =>
                readSwitchWithToSwitchWithMap(readSwitchWith)
              )
            )
          );
          dispatch(setResponse(parseAxiosResponse(response)));
        } else {
          dispatch(setResponse(parseAxiosResponse(response)));
          dispatch(setFlashError('取得が失敗しました。'));
        }
      },
    };
  }

  getDetail(companyId: string, switchId: string) {
    return {
      request:
        (data: Record<string, any>): AppThunk =>
        async (dispatch) => {
          const response = await this.caller.GET(
            `/${companyId}/switches/${switchId}`,
            data
          );
          if (response.status === 201) {
            dispatch(
              companySwitchGetSuccess(
                readSwitchWithToSwitchWithMap(response.data)
              )
            );
            dispatch(setResponse(parseAxiosResponse(response)));
            await sleep(200);
            dispatch(setFlashSuccess('追加しました'));
          } else {
            dispatch(
              setResponse({
                ...parseAxiosResponse(response),
                position: ErrorPosition.DRAWR,
              })
            );
            dispatch(setFlashError('追加が失敗しました。'));
          }
        },
    };
  }

  putUpdate(companyId: string, switchId: string) {
    return {
      request:
        (data: Record<string, any>): AppThunk =>
        async (dispatch) => {
          const response = await this.caller.PUT(
            `/${companyId}/switches/${switchId}`,
            data
          );

          if (response.status === 200) {
            dispatch(
              companySwitchUpdateSuccess(
                readSwitchWithToSwitchWithMap(response.data)
              )
            );
            dispatch(setResponse(parseAxiosResponse(response)));
            await sleep(200);
            dispatch(setFlashSuccess('追加しました'));
          } else {
            dispatch(
              setResponse({
                ...parseAxiosResponse(response),
                position: ErrorPosition.DRAWR,
              })
            );
            dispatch(setFlashError('追加が失敗しました。'));
          }
        },
    };
  }

  unAttach(companyId: number) {
    return {
      request: (): AppThunk => async (dispatch) => {
        const response = await this.caller.GET(
          `/${companyId}/switch_without_company`
        );
        if (response.status === 200) {
          dispatch(
            companySetUnAttachSwitches({
              companyId,
              switches: response.data.map((readSwitchWith: any) =>
                readSwitchWithToSwitchWithMap(readSwitchWith)
              ),
            })
          );
          dispatch(setResponse(parseAxiosResponse(response)));
        } else {
          dispatch(
            setResponse({
              ...parseAxiosResponse(response),
              position: ErrorPosition.DRAWR,
            })
          );
          dispatch(setFlashError('取得が失敗しました。'));
        }
      },
    };
  }

  attach(companyId: number, switchId: string) {
    return {
      request: (): AppThunk => async (dispatch) => {
        const response = await this.caller.PUT(
          `/${companyId}/switches/${switchId}/attach`
        );

        if (response.status === 200) {
          dispatch(
            companySwitchRentSuccess(
              readSwitchWithToSwitchWithMap(response.data)
            )
          );
          dispatch(setResponse(parseAxiosResponse(response)));
          await sleep(200);
          dispatch(setFlashSuccess('追加しました'));
        } else {
          dispatch(
            setResponse({
              ...parseAxiosResponse(response),
              position: ErrorPosition.DRAWR,
            })
          );
          dispatch(setFlashError('追加が失敗しました。'));
        }
      },
    };
  }

  detach(companyId: number, switchId: string) {
    return {
      request: (): AppThunk => async (dispatch) => {
        const response = await this.caller.PUT(
          `/${companyId}/switches/${switchId}/detach`
        );
        dispatch(setResponse(parseAxiosResponse(response)));
        if (response.status === 200) {
          dispatch(
            companyAddUnAttachSwitches({
              companyId,
              switches: [readSwitchWithToSwitchWithMap(response.data)],
            })
          );
          dispatch(setFlashSuccess('削除しました'));
          dispatch(companySwitchesDetachById([Number(switchId)]));
        } else {
          dispatch(setFlashError(response.data.error));
        }
      },
    };
  }

  getByCompanyId(companyId: number) {
    return {
      request: (): AppThunk => async (dispatch) => {
        const response = await this.caller.GET(
          `/${companyId}/switch_without_module`
        );

        if (response.status === 200) {
          dispatch(
            companySetUnAttachSwitchesModule({
              companyId,
              switches: response.data.map((readSwitchWith: any) =>
                readSwitchWithToSwitchWithMap(readSwitchWith)
              ),
            })
          );
          dispatch(setResponse(parseAxiosResponse(response)));
        } else {
          dispatch(setResponse(parseAxiosResponse(response)));
          dispatch(setFlashError('取得が失敗しました'));
        }
      },
    };
  }
}

const companiesSwitchesRequest = new CompaniesSwitchesRequest();
export default companiesSwitchesRequest;
